export default {
    root: {
        class: [
            // Position and Overflow
            'tw-overflow-hidden',
            'tw-relative',
            // Shape and Size
            'tw-border-0',
            'tw-h-6',
            'tw-rounded-md',
            // Colors
            'tw-bg-gray-100 dark:tw-bg-gray-700',
        ],
    },
    value: function (_a) {
        var props = _a.props;
        return ({
            class: [
                // Flexbox & Overflow & Position
                { 'tw-absolute tw-flex tw-items-center tw-justify-center tw-overflow-hidden': props.mode !== 'indeterminate' },
                // Colors
                'tw-bg-primary-500',
                // Spacing & Sizing
                'tw-m-0',
                { 'tw-h-full tw-w-0': props.mode !== 'indeterminate' },
                // Shape
                'tw-border-0',
                // Transitions
                {
                    'tw-transition-width tw-duration-200 tw-ease-in-out': props.mode !== 'indeterminate',
                },
                // Before & After (indeterminate)
                {
                    'before:tw-absolute before:tw-top-0 before:tw-left-0 before:tw-bottom-0 before:tw-bg-inherit': props.mode == 'indeterminate',
                    'after:tw-absolute after:tw-top-0 after:tw-left-0 after:tw-bottom-0 after:tw-bg-inherit after:tw-delay-1000': props.mode == 'indeterminate',
                },
            ],
        });
    },
    label: {
        class: [
            // Flexbox
            'tw-inline-flex',
            // Font and Text
            'tw-text-white dark:tw-text-gray-900',
            'tw-text-md tw-font-light',
        ],
    },
};
